// A commponent with h1 tag at the center and h3 below it. 3 tabs buttons for all, poem, story. Onclick of tab button show all, poem or story cards. Each card should have a title, description and a button to read more. The card should be responsive and look good on mobile and desktop. The card should have a hover effect that changes the background color and shows the read more button.
import React, { useState } from "react";
import stories from "../stories";
import poems from "../poems";
import StoryCardWide from "./storycardWide";
import PoemCardWide from "./poemCardWide";  

const Creations = () => {
    const [selectedTab, setSelectedTab] = useState("all");

    const handleTabClick = (tab) => {
        setSelectedTab(tab);
    };

    return (
        <div>
          <h2 className="text-3xl font-bold text-center my-8">अनुक्रमणिका</h2>
          <p className="text-lg text-center mb-8">
            यहां आप मेरी कहानियों और कविताओं का आनंद ले सकते हैं। सभी रचनाएँ एकत्रित रूप से प्रस्तुत की गई हैं।
          </p>
          <div className="flex justify-center mb-8">
            <button
              className={`bg-blue-500 text-white text-2xl px-5 py-2  hover:bg-blue-600 ${
                selectedTab === "all" ? "bg-blue-700" : ""
              }`}
              onClick={() => handleTabClick("all")}
            >
              सभी रचनाएँ
            </button>
            <button
              className={`bg-blue-500 text-white text-2xl px-5 py-2  hover:bg-blue-600 ${
                selectedTab === "story" ? "bg-blue-700" : ""
              }`}
              onClick={() => handleTabClick("story")}
            >
              कहानियाँ
            </button>
            <button
              className={`bg-blue-500 text-white text-2xl px-5 py-2  hover:bg-blue-600 ${
                selectedTab === "poem" ? "bg-blue-700" : ""
              }`}
              onClick={() => handleTabClick("poem")}
            >
              कविताएँ
            </button>
          </div>
    
          {selectedTab === "all" && (
            <div className="flex flex-col items-center sm:grid sm:grid-cols-3 md:grid-cols-4 gap-2">
              {stories.map((story, index) => (
                <StoryCardWide key={index} story={story} />
              ))}
              {poems.map((poem, index) => (
                <PoemCardWide key={index} poem={poem} />
              ))}
            </div>
          )}
    
          {selectedTab === "story" && (
            <div className="flex flex-col items-center sm:grid sm:grid-cols-3 md:grid-cols-4 gap-2">
              {stories.map((story, index) => (
                <StoryCardWide key={index} story={story} />
              ))}
            </div>
          )}
    
          {selectedTab === "poem" && (
            <div className="flex flex-col items-center sm:grid sm:grid-cols-3 md:grid-cols-4 gap-2">
              {poems.map((poem, index) => (
                <PoemCardWide key={index} poem={poem} />
              ))}
            </div>
          )}
        </div>
      );
    };

export default Creations